import { ApiError } from '@/lib/api-error';

/** A report route's structured refusal: FastAPI puts `{error_code, reason}` in the error detail. */
export interface ReportRefusal {
  errorCode: string;
  reason: string;
}

export function reportRefusal(error: unknown): ReportRefusal | null {
  if (!(error instanceof ApiError) || error.detail === null || typeof error.detail !== 'object') return null;
  const { error_code: errorCode, reason } = error.detail as { error_code?: unknown; reason?: unknown };
  if (typeof errorCode !== 'string' || typeof reason !== 'string') return null;
  return { errorCode, reason };
}

export function refusalReason(error: unknown): string {
  const refusal = reportRefusal(error);
  if (refusal) return refusal.reason;
  if (error instanceof Error) return error.message;
  return String(error);
}
